import React, { useEffect, useState } from "react";
import { useFetchData } from "../../apiHelpers";
import CardWithTable from "../../components/CardWithTable";
import Disclosures from "../../components/Disclosures";
import { API_ROUTES } from "../../constants";
import Sidebar from "../../templates/Sidebar";
import "./weeklyReports.scss";

const WeeklyReports = () => {
  const [lists, setLists] = useState([]);
  const columns = [
    {
      label: "Report Name",
      key: "reportName",
      isSortable: true,
    },
  ];

  const { data: weeklyReportsData } = useFetchData({
    url: API_ROUTES.WEEKLY_REPORTS,
  });

  useEffect(() => {
    if (weeklyReportsData) {
      setLists(weeklyReportsData);
    }
  }, [weeklyReportsData]);

  const getDisclosureBodyContent = (showTooltipOnLoad) => [
    {
      heading: "Marketing Communication",
      content: (
        <>
          <p>
            Investments in fixed-income securities are subject to market,
            interest rate, credit and other risks. Bond prices fluctuate
            inversely to changes in interest rates. Therefore, a general rise in
            interest rates can result in the decline in the bond’s price. Credit
            risk is the risk that an issuer will default on payments of interest
            and/or principal. This risk is heightened in lower rated bonds. If
            sold prior to maturity, fixed income securities are subject to
            market risk. All fixed income investments may be worth less than
            their original cost upon redemption or maturity.
          </p>
          <p>
            This material has been prepared by Allspring Global Investments,
            LLC, a registered Investment Advisor, and the material is intended
            for use by investment professionals with their clients. This
            material is for general informational and educational purposes only
            and is NOT intended to provide investment advice or a recommendation
            of any kind — including a recommendation for any specific
            investment, strategy, or plan.
          </p>
          <p>
            Allspring Global InvestmentsTM is the trade name for the asset
            management firms of Allspring Global Investments Holdings, LLC, a
            holding company indirectly owned by certain private funds of GTCR
            LLC and Reverence Capital Partners, L.P. These firms include but are
            not limited to Allspring Global Investments, LLC, and Allspring
            Funds Management, LLC. Certain products managed by Allspring
            entities are distributed by Allspring Funds Distributor, LLC (a
            broker-dealer and Member FINRA/SIPC).
          </p>
          <p>
            Wells Fargo Advisors is registered with the U.S. Securities and
            Exchange Commission and the Financial Industry Regulatory Authority,
            but is not licensed or registered with any financial services
            regulatory authority outside of the U.S. Non-U.S. residents who
            maintain U.S.-based financial services accounts with Wells Fargo
            Advisors may not be afforded certain protections conferred by
            legislation and regulations in their country of residence in respect
            of any investments, investment transactions or communications made
            with Wells Fargo Advisors. Wells Fargo Advisors is a trade name used
            by Wells Fargo Clearing Services, LLC and Wells Fargo Advisors
            Financial Network, LLC, members SIPC, separate registered
            broker-dealers and non-bank affiliates of Wells Fargo & Company.
          </p>
        </>
      ),
    },
    {
      heading: "What exactly is a Transition Summary?",
      content: (
        <>
          <p>
            Investors seeking to transition their existing portfolio in-kind to
            a new managed strategy should be aware of tax liability and risk
            implications. Providing various transition options to reduce risk
            gap (i.e. tracking error) between client's current portfolio and
            target strategy while minimizing tax drag is the primary objective
            of transition analysis. This summary highlights the various
            implementation choices by showcasing the trade-offs across two
            critical factors - one, tracking error, a measure of closeness of
            client portfolio to target portfolio; and two, tax liability, the
            tax cost of realizing any embedded capital gains in the client
            portfolio during the transition. By reviewing these various
            implementation choices and understanding the trade-offs between
            tracking error and tax liability, an FA and their client can then
            make an informed decision on how to transition their portfolio to
            the new strategy in an optimal way that suits their needs.
          </p>
          <p>
            The total cost basis for each security position and the unrealized
            gain/loss are provided solely for your convenience and may not be
            used for tax purposes or otherwise relied upon. Tax calculations are
            only provided for your convenience and should not be relied on for
            tax purposes. Please consult your tax advisor for questions related
            to the tax treatment of your investments. Unrealized gain/loss are
            based on cost basis as provided as is
          </p>
        </>
      ),
    },
    {
      heading: "Meeting the expectation",
      content: (
        <ul>
          <li>Not Insured by the FDIC or Any Federal Government Agency</li>
          <li>
            Not a Deposit or Other Obligation of, or Guaranteed by, the Bank or
            Any Bank Affiliate
          </li>
          <li>
            Subject to Investments Risks, Including Possible Loss of the
            Principal Amount Invested
          </li>
        </ul>
      ),
      tooltipText: {
        heading: "Another tooltip",
        content:
          "Any matured bonds will be treated as cash and invested toward the model portfolio",
        showTooltipOnLoad: showTooltipOnLoad,
      },
    },
  ];

  const disclosureArgs = {
    heading: "Disclosures",
    className: "disclosures--proposal",
    bodyContent: getDisclosureBodyContent(false),
    isReportPage: false,
  };

  const sidebarArgs = {};

  return (
    <>
      <div className="page page--weekly-proposals page--default">
        <div className="page__wrapper">
          <Sidebar {...sidebarArgs} isWeeklyReportPage={true} />
          <main className="main">
            <div className="main__wrapper">
              <div className="section">
                <header className="section-title">
                  <div>
                    <h1>Weekly Reports</h1>
                  </div>
                </header>
                <CardWithTable
                  title="Weekly Reports"
                  titleNumber={lists.length}
                  id="weekly-reports"
                  columns={columns}
                  tableData={lists}
                  counterToggle={true}
                />
                <div className="list-disclosures">
                  <Disclosures {...disclosureArgs} />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default WeeklyReports;
